<template>
  <div class="d-flex align-items-center" style="width: max-content; gap: 10px;">
    <div
      v-b-tooltip.hover
      title="Link"
      class="d-flex align-items-center cursor-pointer"
      @click="link"
    >
      <div 
        class="fs-14 text-hover-blue" 
        :class="{ 
          'text-blue': Boolean(_value.type),
        }"
      >
        <i class="far fa-link" />
      </div>
    </div>
    <div
      v-if="_value.type"
      v-b-tooltip.hover
      title="Unlink"
      class="d-flex align-items-center cursor-pointer"
      @click="unlink"
    >
      <div class="fs-14 text-hover-blue">
        <i class="far fa-unlink" />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    value: {}
  },
  data() {
    return {
      valueDefault: {
        type: null,
        target: null,
        url: null,
        pageID: null,
        sectionPageID: null,
        sectionID: null,
        email: null,
        emailSubject: null,
        phone: null,
        phoneCountry: null,
        phoneFormat: null,
        fileID: null,
        fileUrl: null,
        fileName: null,
      },
      valueUnlink: {
        type: null,
        target: null,
        url: null,
        pageID: null,
        sectionPageID: null,
        sectionID: null,
        email: null,
        emailSubject: null,
        phone: null,
        phoneCountry: null,
        phoneFormat: null,
        fileID: null,
        fileUrl: null,
        fileName: null,
      }
    }
  },
  computed: {
    _value() {
      return {
        ...this.valueDefault,
        ...this.value,
      }
    }
  },
  methods: {
    link() {
      this.$emit('open');
      this.$store.dispatch("designIframe/modals/setModal", {
        modal_id: "modal-add-link-widget-tools",
        payload: {
          ...this._value,
        },
        callback:{
          save: (value) => {
            this.$emit('save', value);
          },
          cancel: () => {
            this.$emit('cancel');
          },
          close: () => {
            this.$emit('close');
          },
        },
      });
    },
    unlink() {
      this.$emit('unlink');
    },
  },
};
</script>
